module.exports = __webpack_public_path__ + "img/1227518993.9168781f.jpg";